import { polygonId } from '../constants';
import {
  BSC_ABI_FACTORY,
  POL_ABI_FACTORY,
} from '../constants/abi';

export const getAbisByChainId = (chainId: string) => {
  switch (chainId) {
    case polygonId:
      return {
        ABI_FACTORY: POL_ABI_FACTORY,
      };

    default:
      return {
        ABI_FACTORY: BSC_ABI_FACTORY,
      };
  }
};
